module.exports = __webpack_public_path__ + "img/icon-banner-dex-point.5a8a03cf.svg";